import * as types from './mutation-types'
import UserModel from 'models/user'
import sessionstorage from 'utils/sessionstorage'
import axios from 'axios'

export function login ({ commit }, opts) {
  return UserModel.login(opts).then(val => {
    sessionstorage.setItem('token', val.token)
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + val.token
    commit(types.USER_INFO, val)
  })
}

export function loginStatus ({ commit }) {
  return sessionstorage.getItem('token').then(token => {
    if (!token) {
      global.location.replace('#/login')
    } else {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      return UserModel.loginStatus().then(val => {
        commit(types.USER_INFO, val)
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/store/user/actions.js